import { Box, FormLabelOptional, VisuallyHidden } from '@vp/swan';
import { __ } from '@99designs/i18n';

interface RequiredIndicatorProps {
    isRequired: boolean;
    isOmitted?: boolean;
}

export default function RequiredIndicator(props: RequiredIndicatorProps) {
    if (props.isOmitted) {
        return null;
    }

    return props.isRequired ? (
        <>
            <Box aria-hidden="true" as="span" ml={'2'}>
                *
            </Box>
            <VisuallyHidden>({__('Required')})</VisuallyHidden>
        </>
    ) : (
        <FormLabelOptional> ({__('Optional')})</FormLabelOptional>
    );
}
